// Import all misc SVGs as React components
import { MinimalSymbol } from 'features/processFlowDiagrams/data/MinimalSymbols'
import AeratorWithSparger from 'features/processFlowDiagrams/svg/misc/aerator-with-sparger.svg?react'
import AirCooler from 'features/processFlowDiagrams/svg/misc/air-cooler.svg?react'
import AirFilter from 'features/processFlowDiagrams/svg/misc/air-filter.svg?react'
import AirSeparator from 'features/processFlowDiagrams/svg/misc/air-separator.svg?react'
import BackDraftDamper from 'features/processFlowDiagrams/svg/misc/back-draft-damper.svg?react'
import BagFillingMachine from 'features/processFlowDiagrams/svg/misc/bag-filling-machine.svg?react'
import BeltSkimmer from 'features/processFlowDiagrams/svg/misc/belt-skimmer.svg?react'
import Bin from 'features/processFlowDiagrams/svg/misc/bin.svg?react'
import BoilerDome from 'features/processFlowDiagrams/svg/misc/boiler-dome.svg?react'
import BoilerDomeHotLiquid from 'features/processFlowDiagrams/svg/misc/boiler-dome-hot-liquid.svg?react'
import BoxTruck from 'features/processFlowDiagrams/svg/misc/box-truck.svg?react'
import BucketElevator from 'features/processFlowDiagrams/svg/misc/bucket-elevator.svg?react'
import Chiller from 'features/processFlowDiagrams/svg/misc/chiller.svg?react'
import CombustionChamber from 'features/processFlowDiagrams/svg/misc/combustion-chamber.svg?react'
import Conveyor from 'features/processFlowDiagrams/svg/misc/conveyor.svg?react'
import ConveyorBelt from 'features/processFlowDiagrams/svg/misc/conveyor-belt.svg?react'
import ConveyorBeltClosed from 'features/processFlowDiagrams/svg/misc/conveyor-belt-closed.svg?react'
import ConveyorBeltClosedReversible from 'features/processFlowDiagrams/svg/misc/conveyor-belt-closed-reversible.svg?react'
import ConveyorChainClosed from 'features/processFlowDiagrams/svg/misc/conveyor-chain-closed.svg?react'
import ConveyorScrewClosed from 'features/processFlowDiagrams/svg/misc/conveyor-screw-closed.svg?react'
import ConveyorVibratingClosed from 'features/processFlowDiagrams/svg/misc/conveyor-vibrating-closed.svg?react'
import Cooler from 'features/processFlowDiagrams/svg/misc/cooler.svg?react'
import CoolingTower from 'features/processFlowDiagrams/svg/misc/cooling-tower.svg?react'
import CoolingTowerDryForcedDraught from 'features/processFlowDiagrams/svg/misc/cooling-tower-dry-forced-draught.svg?react'
import CoolingTowerDryInducedDraught from 'features/processFlowDiagrams/svg/misc/cooling-tower-dry-induced-draught.svg?react'
import CoolingTowerDryNaturalDraught from 'features/processFlowDiagrams/svg/misc/cooling-tower-dry-natural-draught.svg?react'
import CoolingTowerWetDryNaturalDraught from 'features/processFlowDiagrams/svg/misc/cooling-tower-wet-dry-natural-draught.svg?react'
import CoolingTowerWetForcedDraught from 'features/processFlowDiagrams/svg/misc/cooling-tower-wet-forced-draught.svg?react'
import CoolingTowerWetInducedDraught from 'features/processFlowDiagrams/svg/misc/cooling-tower-wet-induced-draught.svg?react'
import CoolingTowerWetNaturalDraught from 'features/processFlowDiagrams/svg/misc/cooling-tower-wet-natural-draught.svg?react'
import CoveredGasVent from 'features/processFlowDiagrams/svg/misc/covered-gas-vent.svg?react'
import Crane from 'features/processFlowDiagrams/svg/misc/crane.svg?react'
import CurvedGasVent from 'features/processFlowDiagrams/svg/misc/curved-gas-vent.svg?react'
import Cyclone from 'features/processFlowDiagrams/svg/misc/cyclone.svg?react'
import Dryer from 'features/processFlowDiagrams/svg/misc/dryer.svg?react'
import ElevatorBucket from 'features/processFlowDiagrams/svg/misc/elevator-bucket.svg?react'
import ElevatorBucketZForm from 'features/processFlowDiagrams/svg/misc/elevator-bucket-z-form.svg?react'
import Fan from 'features/processFlowDiagrams/svg/misc/fan.svg?react'
import Fan2 from 'features/processFlowDiagrams/svg/misc/fan-2.svg?react'
import Filter from 'features/processFlowDiagrams/svg/misc/filter.svg?react'
import Filter2 from 'features/processFlowDiagrams/svg/misc/filter-2.svg?react'
import FiringSystemBurner from 'features/processFlowDiagrams/svg/misc/firing-system-burner.svg?react'
import FlameArrestor from 'features/processFlowDiagrams/svg/misc/flame-arrestor.svg?react'
import FlexiblePipe from 'features/processFlowDiagrams/svg/misc/flexible-pipe.svg?react'
import ForcedFlowAirCooler from 'features/processFlowDiagrams/svg/misc/forced-flow-air-cooler.svg?react'
import ForkliftManual from 'features/processFlowDiagrams/svg/misc/forklift-manual.svg?react'
import ForkliftTruck from 'features/processFlowDiagrams/svg/misc/forklift-truck.svg?react'
import Funnel from 'features/processFlowDiagrams/svg/misc/funnel.svg?react'
import GasFlare from 'features/processFlowDiagrams/svg/misc/gas-flare.svg?react'
import InducedFlowAirCooler from 'features/processFlowDiagrams/svg/misc/induced-flow-air-cooler.svg?react'
import IndustrialTruck from 'features/processFlowDiagrams/svg/misc/industrial-truck.svg?react'
import Lift from 'features/processFlowDiagrams/svg/misc/lift.svg?react'
import LoadingArm from 'features/processFlowDiagrams/svg/misc/loading-arm.svg?react'
import Mixer from 'features/processFlowDiagrams/svg/misc/mixer.svg?react'
import Palletizer from 'features/processFlowDiagrams/svg/misc/palletizer.svg?react'
import ProtectivePaletteCovering from 'features/processFlowDiagrams/svg/misc/protective-palette-covering.svg?react'
import RollerConveyor from 'features/processFlowDiagrams/svg/misc/roller-conveyor.svg?react'
import RollingBin from 'features/processFlowDiagrams/svg/misc/rolling-bin.svg?react'
import RotaryScreen from 'features/processFlowDiagrams/svg/misc/rotary-screen.svg?react'
import ScreeningDeviceSieveStrainer from 'features/processFlowDiagrams/svg/misc/screening-device-sieve-strainer.svg?react'
import ScreeningDeviceSieveStrainerBasketReel from 'features/processFlowDiagrams/svg/misc/screening-device-sieve-strainer-basket-reel.svg?react'
import ScreeningDeviceSieveStrainerCoarseAndFineScreens from 'features/processFlowDiagrams/svg/misc/screening-device-sieve-strainer-coarse-and-fine-screens.svg?react'
import ScreeningDeviceSieveStrainerCoarseRake from 'features/processFlowDiagrams/svg/misc/screening-device-sieve-strainer-coarse-rake.svg?react'
import ScreeningDeviceSieveStrainerFineRake from 'features/processFlowDiagrams/svg/misc/screening-device-sieve-strainer-fine-rake.svg?react'
import ScreeningDeviceSieveStrainerRotatingDrum from 'features/processFlowDiagrams/svg/misc/screening-device-sieve-strainer-rotating-drum.svg?react'
import ScreeningDeviceSieveStrainerVibrating from 'features/processFlowDiagrams/svg/misc/screening-device-sieve-strainer-vibrating.svg?react'
import Ship from 'features/processFlowDiagrams/svg/misc/ship.svg?react'
import Silencer from 'features/processFlowDiagrams/svg/misc/silencer.svg?react'
import SprayCooler from 'features/processFlowDiagrams/svg/misc/spray-cooler.svg?react'
import SprayingDevice from 'features/processFlowDiagrams/svg/misc/spraying-device.svg?react'
import StackChimney from 'features/processFlowDiagrams/svg/misc/stack-chimney.svg?react'
import SteamTrap from 'features/processFlowDiagrams/svg/misc/steam-trap.svg?react'
import TankCarTankWagon from 'features/processFlowDiagrams/svg/misc/tank-car-tank-wagon.svg?react'
import ViewingGlass from 'features/processFlowDiagrams/svg/misc/viewing-glass.svg?react'
import React from 'react'

export const PID_MISC_SYMBOLS: MinimalSymbol[] = [
  {
    id: 'aerator-with-sparger',
    name: 'Aerator With Sparger',
    category: 'misc',
    svgContent: <AeratorWithSparger />,
    viewBox: '0 0 35 97',
  },
  {
    id: 'air-cooler',
    name: 'Air Cooler',
    category: 'misc',
    svgContent: <AirCooler />,
    viewBox: '0 0 70 20',
  },
  {
    id: 'air-filter',
    name: 'Air Filter',
    category: 'misc',
    svgContent: <AirFilter />,
    viewBox: '0 0 40 65',
  },
  {
    id: 'air-separator',
    name: 'Air Separator',
    category: 'misc',
    svgContent: <AirSeparator />,
    viewBox: '0 0 65 106',
  },
  {
    id: 'back-draft-damper',
    name: 'Back Draft Damper',
    category: 'misc',
    svgContent: <BackDraftDamper />,
    viewBox: '0 0 62 32',
  },
  {
    id: 'bag-filling-machine',
    name: 'Bag Filling Machine',
    category: 'misc',
    svgContent: <BagFillingMachine />,
    viewBox: '0 0 80 100',
  },
  {
    id: 'belt-skimmer',
    name: 'Belt Skimmer',
    category: 'misc',
    svgContent: <BeltSkimmer />,
    viewBox: '0 0 70 98',
  },
  {
    id: 'bin',
    name: 'Bin',
    category: 'misc',
    svgContent: <Bin />,
    viewBox: '0 0 100 65',
  },
  {
    id: 'boiler-dome',
    name: 'Boiler (Dome)',
    category: 'misc',
    svgContent: <BoilerDome />,
    viewBox: '0 0 100 120',
  },
  {
    id: 'boiler-dome-hot-liquid',
    name: 'Boiler (Dome, Hot Liquid)',
    category: 'misc',
    svgContent: <BoilerDomeHotLiquid />,
    viewBox: '0 0 100 120',
  },
  {
    id: 'box-truck',
    name: 'Box Truck',
    category: 'misc',
    svgContent: <BoxTruck />,
    viewBox: '0 0 120 80',
  },
  {
    id: 'bucket-elevator',
    name: 'Bucket Elevator',
    category: 'misc',
    svgContent: <BucketElevator />,
    viewBox: '0 0 65 200',
  },
  {
    id: 'chiller',
    name: 'Chiller',
    category: 'misc',
    svgContent: <Chiller />,
    viewBox: '0 0 156 115',
  },
  {
    id: 'combustion-chamber',
    name: 'Combustion Chamber',
    category: 'misc',
    svgContent: <CombustionChamber />,
    viewBox: '0 0 130 100',
  },
  {
    id: 'conveyor',
    name: 'Conveyor',
    category: 'misc',
    svgContent: <Conveyor />,
    viewBox: '0 0 200 60',
  },
  {
    id: 'conveyor-belt',
    name: 'Conveyor (Belt)',
    category: 'misc',
    svgContent: <ConveyorBelt />,
    viewBox: '0 0 200 50',
  },
  {
    id: 'conveyor-belt-closed',
    name: 'Conveyor (Belt, Closed)',
    category: 'misc',
    svgContent: <ConveyorBeltClosed />,
    viewBox: '0 0 240 80',
  },
  {
    id: 'conveyor-belt-closed-reversible',
    name: 'Conveyor (Belt, Closed, Reversible)',
    category: 'misc',
    svgContent: <ConveyorBeltClosedReversible />,
    viewBox: '0 0 240 80',
  },
  {
    id: 'conveyor-chain-closed',
    name: 'Conveyor (Chain, Closed)',
    category: 'misc',
    svgContent: <ConveyorChainClosed />,
    viewBox: '0 0 240 80',
  },
  {
    id: 'conveyor-screw-closed',
    name: 'Conveyor (Screw, Closed)',
    category: 'misc',
    svgContent: <ConveyorScrewClosed />,
    viewBox: '0 0 220 80',
  },
  {
    id: 'conveyor-vibrating-closed',
    name: 'Conveyor (Vibrating, Closed)',
    category: 'misc',
    svgContent: <ConveyorVibratingClosed />,
    viewBox: '0 0 240 80',
  },
  {
    id: 'cooler',
    name: 'Cooler',
    category: 'misc',
    svgContent: <Cooler />,
    viewBox: '0 0 85 90',
  },
  {
    id: 'cooling-tower',
    name: 'Cooling Tower',
    category: 'misc',
    svgContent: <CoolingTower />,
    viewBox: '0 0 100 120',
  },
  {
    id: 'cooling-tower-dry-forced-draught',
    name: 'Cooling Tower (Dry, Forced Draught)',
    category: 'misc',
    svgContent: <CoolingTowerDryForcedDraught />,
    viewBox: '0 0 100 120',
  },
  {
    id: 'cooling-tower-dry-induced-draught',
    name: 'Cooling Tower (Dry, Induced Draught)',
    category: 'misc',
    svgContent: <CoolingTowerDryInducedDraught />,
    viewBox: '0 0 100 120',
  },
  {
    id: 'cooling-tower-dry-natural-draught',
    name: 'Cooling Tower (Dry, Natural Draught)',
    category: 'misc',
    svgContent: <CoolingTowerDryNaturalDraught />,
    viewBox: '0 0 100 120',
  },
  {
    id: 'cooling-tower-wet-forced-draught',
    name: 'Cooling Tower (Wet, Forced Draught)',
    category: 'misc',
    svgContent: <CoolingTowerWetForcedDraught />,
    viewBox: '0 0 100 120',
  },
  {
    id: 'cooling-tower-wet-induced-draught',
    name: 'Cooling Tower (Wet, Induced Draught)',
    category: 'misc',
    svgContent: <CoolingTowerWetInducedDraught />,
    viewBox: '0 0 100 120',
  },
  {
    id: 'cooling-tower-wet-natural-draught',
    name: 'Cooling Tower (Wet, Natural Draught)',
    category: 'misc',
    svgContent: <CoolingTowerWetNaturalDraught />,
    viewBox: '0 0 100 120',
  },
  {
    id: 'cooling-tower-wet-dry-natural-draught',
    name: 'Cooling Tower (Wet-Dry, Natural Draught)',
    category: 'misc',
    svgContent: <CoolingTowerWetDryNaturalDraught />,
    viewBox: '0 0 100 120',
  },
  {
    id: 'covered-gas-vent',
    name: 'Covered Gas Vent',
    category: 'misc',
    svgContent: <CoveredGasVent />,
    viewBox: '0 0 80 100',
  },
  {
    id: 'crane',
    name: 'Crane',
    category: 'misc',
    svgContent: <Crane />,
    viewBox: '0 0 100 100',
  },
  {
    id: 'curved-gas-vent',
    name: 'Curved Gas Vent',
    category: 'misc',
    svgContent: <CurvedGasVent />,
    viewBox: '0 0 30 70',
  },
  {
    id: 'cyclone',
    name: 'Cyclone',
    category: 'misc',
    svgContent: <Cyclone />,
    viewBox: '0 0 100 80',
  },
  {
    id: 'dryer',
    name: 'Dryer',
    category: 'misc',
    svgContent: <Dryer />,
    viewBox: '0 0 80 100',
  },
  {
    id: 'elevator-bucket',
    name: 'Elevator (Bucket)',
    category: 'misc',
    svgContent: <ElevatorBucket />,
    viewBox: '0 0 160 250',
  },
  {
    id: 'elevator-bucket-z-form',
    name: 'Elevator (Bucket, Z-Form)',
    category: 'misc',
    svgContent: <ElevatorBucketZForm />,
    viewBox: '0 0 430 250',
  },
  {
    id: 'fan',
    name: 'Fan',
    category: 'misc',
    svgContent: <Fan />,
    viewBox: '0 0 100 100',
  },
  {
    id: 'fan-2',
    name: 'Fan 2',
    category: 'misc',
    svgContent: <Fan2 />,
    viewBox: '0 0 58 8',
  },
  {
    id: 'filter',
    name: 'Filter',
    category: 'misc',
    svgContent: <Filter />,
    viewBox: '0 0 100 100',
  },
  {
    id: 'filter-2',
    name: 'Filter 2',
    category: 'misc',
    svgContent: <Filter2 />,
    viewBox: '0 0 100 100',
  },
  {
    id: 'firing-system-burner',
    name: 'Firing System, Burner',
    category: 'misc',
    svgContent: <FiringSystemBurner />,
    viewBox: '0 0 100 100',
  },
  {
    id: 'flame-arrestor',
    name: 'Flame Arrestor',
    category: 'misc',
    svgContent: <FlameArrestor />,
    viewBox: '0 0 100 40',
  },
  {
    id: 'flexible-pipe',
    name: 'Flexible Pipe',
    category: 'misc',
    svgContent: <FlexiblePipe />,
    viewBox: '0 0 60 16',
  },
  {
    id: 'forced-flow-air-cooler',
    name: 'Forced Flow Air Cooler',
    category: 'misc',
    svgContent: <ForcedFlowAirCooler />,
    viewBox: '0 0 70 30',
  },
  {
    id: 'forklift-manual',
    name: 'Forklift (Manual)',
    category: 'misc',
    svgContent: <ForkliftManual />,
    viewBox: '0 0 140 100',
  },
  {
    id: 'forklift-truck',
    name: 'Forklift (Truck)',
    category: 'misc',
    svgContent: <ForkliftTruck />,
    viewBox: '0 0 140 100',
  },
  {
    id: 'funnel',
    name: 'Funnel',
    category: 'misc',
    svgContent: <Funnel />,
    viewBox: '0 0 40 80',
  },
  {
    id: 'gas-flare',
    name: 'Gas Flare',
    category: 'misc',
    svgContent: <GasFlare />,
    viewBox: '0 0 60 100',
  },
  {
    id: 'induced-flow-air-cooler',
    name: 'Induced Flow Air Cooler',
    category: 'misc',
    svgContent: <InducedFlowAirCooler />,
    viewBox: '0 0 92 30',
  },
  {
    id: 'industrial-truck',
    name: 'Industrial Truck',
    category: 'misc',
    svgContent: <IndustrialTruck />,
    viewBox: '0 0 120 20',
  },
  {
    id: 'lift',
    name: 'Lift',
    category: 'misc',
    svgContent: <Lift />,
    viewBox: '0 0 100 100',
  },
  {
    id: 'loading-arm',
    name: 'Loading Arm',
    category: 'misc',
    svgContent: <LoadingArm />,
    viewBox: '0 0 120 80',
  },
  {
    id: 'mixer',
    name: 'Mixer',
    category: 'misc',
    svgContent: <Mixer />,
    viewBox: '0 0 80 100',
  },
  {
    id: 'palletizer',
    name: 'Palletizer',
    category: 'misc',
    svgContent: <Palletizer />,
    viewBox: '0 0 80 100',
  },
  {
    id: 'protective-palette-covering',
    name: 'Protective Palette Covering',
    category: 'misc',
    svgContent: <ProtectivePaletteCovering />,
    viewBox: '0 0 80 100',
  },
  {
    id: 'roller-conveyor',
    name: 'Roller Conveyor',
    category: 'misc',
    svgContent: <RollerConveyor />,
    viewBox: '0 0 160 20',
  },
  {
    id: 'rolling-bin',
    name: 'Rolling Bin',
    category: 'misc',
    svgContent: <RollingBin />,
    viewBox: '0 0 100 65',
  },
  {
    id: 'rotary-screen',
    name: 'Rotary Screen',
    category: 'misc',
    svgContent: <RotaryScreen />,
    viewBox: '0 0 100 65',
  },
  {
    id: 'screening-device-sieve-strainer',
    name: 'Screening Device, Sieve, Strainer',
    category: 'misc',
    svgContent: <ScreeningDeviceSieveStrainer />,
    viewBox: '0 0 80 120',
  },
  {
    id: 'screening-device-sieve-strainer-basket-reel',
    name: 'Screening Device, Sieve, Strainer (Basket Reel)',
    category: 'misc',
    svgContent: <ScreeningDeviceSieveStrainerBasketReel />,
    viewBox: '0 0 80 180',
  },
  {
    id: 'screening-device-sieve-strainer-coarse-and-fine-screens',
    name: 'Screening Device, Sieve, Strainer (Coarse and Fine Screens)',
    category: 'misc',
    svgContent: <ScreeningDeviceSieveStrainerCoarseAndFineScreens />,
    viewBox: '0 0 80 120',
  },
  {
    id: 'screening-device-sieve-strainer-coarse-rake',
    name: 'Screening Device, Sieve, Strainer (Coarse Rake)',
    category: 'misc',
    svgContent: <ScreeningDeviceSieveStrainerCoarseRake />,
    viewBox: '0 0 80 120',
  },
  {
    id: 'screening-device-sieve-strainer-fine-rake',
    name: 'Screening Device, Sieve, Strainer (Fine Rake)',
    category: 'misc',
    svgContent: <ScreeningDeviceSieveStrainerFineRake />,
    viewBox: '0 0 80 120',
  },
  {
    id: 'screening-device-sieve-strainer-rotating-drum',
    name: 'Screening Device, Sieve, Strainer (Rotating Drum)',
    category: 'misc',
    svgContent: <ScreeningDeviceSieveStrainerRotatingDrum />,
    viewBox: '0 0 80 120',
  },
  {
    id: 'screening-device-sieve-strainer-vibrating',
    name: 'Screening Device, Sieve, Strainer (Vibrating)',
    category: 'misc',
    svgContent: <ScreeningDeviceSieveStrainerVibrating />,
    viewBox: '0 0 80 120',
  },
  {
    id: 'ship',
    name: 'Ship',
    category: 'misc',
    svgContent: <Ship />,
    viewBox: '0 0 105 60',
  },
  {
    id: 'silencer',
    name: 'Silencer',
    category: 'misc',
    svgContent: <Silencer />,
    viewBox: '0 0 100 30',
  },
  {
    id: 'spraying-device',
    name: 'Spraying Device',
    category: 'misc',
    svgContent: <SprayingDevice />,
    viewBox: '0 0 60 20',
  },
  {
    id: 'spray-cooler',
    name: 'Spray Cooler',
    category: 'misc',
    svgContent: <SprayCooler />,
    viewBox: '0 0 100 120',
  },
  {
    id: 'stack-chimney',
    name: 'Stack, Chimney',
    category: 'misc',
    svgContent: <StackChimney />,
    viewBox: '0 0 60 100',
  },
  {
    id: 'steam-trap',
    name: 'Steam Trap',
    category: 'misc',
    svgContent: <SteamTrap />,
    viewBox: '0 0 52 52',
  },
  {
    id: 'tank-car-tank-wagon',
    name: 'Tank Car, Tank Wagon',
    category: 'misc',
    svgContent: <TankCarTankWagon />,
    viewBox: '0 0 126 80',
  },
  {
    id: 'viewing-glass',
    name: 'Viewing Glass',
    category: 'misc',
    svgContent: <ViewingGlass />,
    viewBox: '0 0 80 50',
  },
]
